import gql from 'graphql-tag';

export const SEARCH_SERVICE_ADDRESS_QUERY = gql`
  query searchServiceAddress($payload: SearchServiceAddressRequest) {
    searchServiceAddress(payload: $payload) {
      addresses {
        addressLine1
        city
        postal
        premiseIds
        geoLocationToken
      }
    }
  }
`;
